import React, { useEffect, useState } from 'react'
import useMonthlyGenerationDownloadStyles from './styles'
import { GetMonthlyReportNew } from '../../services/api'
import { useLocation } from 'react-router-dom'
import MonthlyReport from '../PlantBusinessView/components/MonthlyReport/MonthlyReport'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const MonthlyGenerationDownload = () => {
  const classes = useMonthlyGenerationDownloadStyles()
  const [monthlyReportList, setMonthlyReportList] = useState([])
  const [Loading, setLoading] = useState(true)
  const { state } = useLocation()
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)

  useEffect(() => {
    const plantId = state?.data?.id
    GetMonthlyReportNew(
      plantId,
      state?.token,
      state?.Fromdate,
      state?.Todate
    ).then((resp) => {
      if (resp) {
        setMonthlyReportList(resp)
        setLoading(false)
      } else {
      }
    })
  }, [])

  return (
    <div className={classes.root}>
      {Loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: `${screenHeight - 200}px`,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        monthlyReportList?.data != null && (
          <MonthlyReport
            monthlyReportList={monthlyReportList}
            state={state?.state}
            fromDate={state?.Fromdate}
            toDate={state?.Todate}
          />
        )
      )}
    </div>
  )
}

MonthlyGenerationDownload.propTypes = {}

export default MonthlyGenerationDownload
